<div class="preview-shell mt-4">
  <!-- Platform tabs -->
  <div class="preview-tabs" *ngIf="platforms.length > 1">
    <button
      *ngFor="let p of platforms"
      type="button"
      class="preview-tab"
      [class.active]="platform === p"
      (click)="selectPlatform(p)"
    >
      {{ platformLabel(p) }}
    </button>
  </div>

  <!-- Device toggle -->
  <div class="preview-toggle" *ngIf="devices.length > 1">
    <button
      *ngFor="let d of devices"
      type="button"
      class="preview-toggle-btn"
      [class.active]="device === d"
      (click)="selectDevice(d)"
    >
      <span class="material-icons">{{ deviceIcon(d) }}</span>
      <span>{{ deviceLabel(d) }}</span>
    </button>
  </div>

  <!-- Placement stepper: prev / dropdown / next -->
  <div class="preview-placement" *ngIf="variants.length > 1">
    <button
      type="button"
      class="preview-placement-arrow"
      aria-label="Previous placement"
      (click)="prev()"
    >
      &lsaquo;
    </button>
    <select
      class="preview-placement-select"
      #sel
      [value]="placementIndex"
      (change)="placementIndex = +sel.value"
    >
      <option *ngFor="let v of variants; let i = index" [value]="i">
        {{ v.label }}
      </option>
    </select>
    <button
      type="button"
      class="preview-placement-arrow"
      aria-label="Next placement"
      (click)="next()"
    >
      &rsaquo;
    </button>
  </div>

  <!-- Active variant mock -->
  <div class="preview-stage">
    <ng-container
      *ngIf="active"
      [ngComponentOutlet]="active.component"
      [ngComponentOutletInputs]="variantInputs"
    ></ng-container>
  </div>
</div>
